import * as React from 'react';
/**
 * @hidden
 */
export var SchedulerResourceIteratorContext = React.createContext({
    resource: {},
    groupIndex: 0
});
/**
 * @hidden
 */
export var useSchedulerResourceIteratorContext = function () { return React.useContext(SchedulerResourceIteratorContext); };
//# sourceMappingURL=SchedulerResourceIteratorContext.js.map